<template>
  <AutoComplete
    data-sb-automation="sb-auto-complete"
    data-sb-regression="sb-auto-complete"
    :class="$style.height"
    :input-class="$style.font"
    :pt="{
      inputMultiple: {
        class: $style.border,
      },
    }"
    :append-to="appendTo"
    @show="toggleDropdown"
    @hide="toggleDropdown"
  >
    <template
      v-for="(_, slotName) in $slots"
      #[slotName]="slotProps"
    >
      <slot
        :name="slotName"
        v-bind="slotProps ?? {}"
        :data-sb-automation="`sb-auto-complete-${slotName}`"
      />
    </template>
    <template #dropdownicon>
      <i
        :class="['sb-icon-caret-down', iconExpanded && $style.iconExpanded]"
        data-sb-automation="sb-auto-complete-dropdown-icon"
      />
    </template>
  </AutoComplete>
</template>

<script setup>
import AutoComplete from 'primevue/autocomplete';
import { useShadowDom } from '@src/mixins/useShadowDom';
import { ref } from 'vue';

const iconExpanded = ref(false);

const toggleDropdown = () => {
  iconExpanded.value = !iconExpanded.value;
};

const appendTo = useShadowDom();
</script>

<style lang="scss" module>
@use '@src/components/AutoComplete/styles/sb-auto-complete.module.scss';
</style>
